<script setup lang="ts">
import {onMounted} from "vue";
import {useFormatStore} from "@/stores/formatStore";
import {useI18n} from "vue-i18n";
import {useItineraryStore} from "@/stores/itineraryStore";
import defaultImage from '@/assets/images/default-itinerary.jpeg';


const {t} = useI18n(); // Import the translation function

const props = defineProps({
  slug: String
})

const itineraryStore = useItineraryStore();
const formatStore = useFormatStore();

onMounted(() => {
  itineraryStore.getAll(1, 10, 'cosmosy', '', true,  { splitHero:false });
})

</script>
<template>

  <div class="w-full">
    <!-- Desktop -->
    <div class="hidden md:block w-full" v-show="!itineraryStore.loading">
      <div class="flex items-end justify-between">
        <span class="responsive-title-2">{{ t('itineraries.title') }}</span>
        <router-link
            :to="`/${$i18n.locale}/itineraries`"
            class="responsive-body-small font-bold underline"
            v-if="itineraryStore.itineraries.length > 1"
        >
          {{ t('itineraries.findMore') }}
        </router-link>
      </div>
      <div class="grid grid-cols-5 gap-6 pt-8" v-if="itineraryStore?.itineraries[0]">
        <!-- First Div (3/5 width) -->
        <div class="col-span-3 flex gap-6">
          <router-link
              class="flex max-w-[550px] w-full"
              :to="`/${$i18n.locale}/page/itineraries/${itineraryStore.itineraries[0]?.slug}`"
          >
            <img
                :src="itineraryStore.itineraries[0]?.imageSet['full'] || defaultImage"
                :alt="itineraryStore.itineraries[0]?.title"
                class="h-[360px] object-cover rounded-2xl w-full border-2 border-primary-blue"
            />
          </router-link>
          <div class="flex flex-col justify-between w-2/5">
            <div class="flex flex-col gap-3">
              <span v-if="itineraryStore.itineraries[0]?.publishedAt" class="responsive-body-small text-gray-500">
                
                {{
                  formatStore.formatDateWithCustomPatternMapping(
                      itineraryStore.itineraries[0]?.publishedAt,
                      'MMM DD, YYYY'
                  )
                }}
              </span>
              <span class="responsive-title-3 font-semibold line-clamp-3">
                {{ itineraryStore.itineraries[0]?.title }}
              </span>
              <span class="responsive-body-small text-gray-500">
                {{ itineraryStore.itineraries[0]?.seoDescription }}
              </span>
            </div>
            <router-link
                :to="`/${$i18n.locale}/page/itineraries/${itineraryStore.itineraries[0]?.slug}`"
                class="bg-primary-blue w-fit rounded-2xl px-5 py-2 flex shadow-md transition transform hover:scale-110"
            >
              <img
                  src="@/assets/icons/svg/Arrow_right_white_16x16.svg"
                  alt="arrow"
              />
            </router-link>
          </div>
        </div>

        <!-- Second and Third Divs (1/5 each) -->
        <div v-for="(itin, index) in itineraryStore.itineraries.slice(1, 3)" :key="index" class="flex flex-col col-span-1 gap-6">
          <router-link :to="`/${$i18n.locale}/page/itineraries/${itin.slug}`" class="flex flex-col gap-1">
            <img
                :src="itin.imageSet['one-half'] || defaultImage"
                :alt="itin.title"
                class="w-full h-[180px] object-cover rounded-2xl border border-gray-300"
            />
            <span v-if="itin.publishedAt" class="responsive-body-small text-gray-500 mt-2">
        {{
                formatStore.formatDateWithCustomPatternMapping(
                    itin.publishedAt,
                    'MMM DD, YYYY'
                )
              }}
      </span>
            <span class="responsive-body-large font-semibold line-clamp-3">
        {{ itin.title }}
      </span>
          </router-link>
        </div>
      </div>
    </div>
    <!-- Mobile -->
    <div class="travel-inspirations__grid mobile flex flex-col gap-8 mt-4 md:hidden visible">
      <span class="responsive-title-1 title-pagelist">{{ t('itineraries.title') }}</span>
      <!-- Scrolling Section -->
      <div class="flex gap-5 overflow-x-auto">
        <div
            v-for="itin in itineraryStore.itineraries"
            :key="itin.id"
            class="flex flex-col gap-2 min-w-[320px]"
        >
          <router-link :to="`/${$i18n.locale}/page/itineraries/${itin.slug}`">
            <div class="aspect-w-4 h-60 mb-2">
              <img
                  :src="itin.imageSet['one-half'] || defaultImage"
                  :alt="itin.title"
                  class="w-full h-full object-cover rounded-2xl"
              />
            </div>
            <span v-if="itin.publishedAt" class="responsive-body-xsmall text-gray-500 mt-2">
          {{
                formatStore.formatDateWithCustomPatternMapping(itin.publishedAt, 'MMM DD, YYYY')
              }}
        </span>
            <h4 class="text-base font-semibold line-clamp-3">
              {{ itin.title }}
            </h4>
          </router-link>
        </div>
      </div>
      <!-- "Find More Itineraries" Link -->
      <router-link
          :to="`/${$i18n.locale}/itineraries`"
          class=" responsive-link-small underline font-bold"
          v-if="itineraryStore.itineraries.length > 1"
      >{{ t('itineraries.findMore') }}
      </router-link>
    </div>
  </div>
</template>

